import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './my404component.cssmodule.scss';
import { Link } from 'react-router';

class My404Component extends React.Component {

  render() {
    return (
      <div className="container my404component-component" styleName="my404component-component">
        <div className="row">
            <div className="col-md-12">
                <div className="error-template" styleName="error-template">
                    <h1>
                        Oops!</h1>
                    <h2>
                        404 Not Found</h2>
                    <div className="error-details">
                        Sorry, an error has occured, Requested page not found!
                    </div>
                    <br /> <img src="/images/logo.gif"/>
                    <br/><br/><br/><br/>
                    <div className="error-actions">
                        <Link to="/" className="btn btn-default btn-lg btn-brand"><span className="glyphicon glyphicon-home"></span>Take Me Home</Link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    );
  }
}

My404Component.displayName = 'My404Component';
My404Component.propTypes = {};
My404Component.defaultProps = {};

export default cssmodules(My404Component, styles);



// WEBPACK FOOTER //
// ./components/404/My404Component.js